import Divider from '../../../atoms/flightBriefPdf/Divider/Divider';
import typo from '../../../atoms/flightBriefPdf/flightBriefTypography.module.css';
import styles from './BriefContact.module.css';

/**
 * Dark contact band: operations icon/label, hotline and duty officer columns
 * separated by vertical dividers.
 * @param {object} props
 * @param {React.ReactNode} [props.operationsIcon] - Icon slot for the operations column.
 * @param {React.ReactNode} props.operations - Operations label (e.g. "24/7 OPERATIONS").
 * @param {React.ReactNode} props.hotlineLabel - Hotline caption.
 * @param {React.ReactNode} props.hotline - Hotline phone number.
 * @param {React.ReactNode} props.dutyOfficerLabel - Duty officer caption.
 * @param {React.ReactNode} props.dutyOfficerName - Duty officer full name.
 * @param {React.ReactNode} [props.dutyOfficerPhone] - Duty officer phone number.
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function BriefContact({
  operationsIcon = null,
  operations,
  hotlineLabel,
  hotline,
  dutyOfficerLabel,
  dutyOfficerName,
  dutyOfficerPhone = null,
  className = '',
}) {
  return (
    <div className={`${styles.contact} ${className}`}>
      <div className={styles.operations}>
        {operationsIcon ? <span className={styles.icon}>{operationsIcon}</span> : null}
        <p className={`${styles['operations-label']} ${typo.p1}`}>{operations}</p>
      </div>
      <div className={styles.column}>
        <p className={`${styles.caption} ${typo.p1}`}>{hotlineLabel}</p>
        <p className={`${styles.value} ${typo.p1}`}>{hotline}</p>
      </div>
      <div className={styles['divider-wrap']} aria-hidden="true">
        <Divider className={styles.divider} />
      </div>
      <div className={styles.column}>
        <p className={`${styles.caption} ${typo.p1}`}>{dutyOfficerLabel}</p>
        <p className={`${styles.value} ${typo.p1}`}>{dutyOfficerName}</p>
        {dutyOfficerPhone ? <p className={`${styles.value} ${typo.p1}`}>{dutyOfficerPhone}</p> : null}
      </div>
    </div>
  );
}

export default BriefContact;
